export const OPTIMUS_LANDING_PATH = '/optimus';
export const VAULTS_LANDING_PAGE_PATH = `/optimus/vaults`;
export const NEW_RESOURCE_PATH = '/optimus/resources/new-resource';